import { useSearchParams, useNavigate } from "react-router-dom"
import { Copy, ArrowLeft } from "lucide-react"
import { useState } from "react"
import { Button } from "@/modules/shared/ui/components/custom/button"

export default function LinkedInSharePage() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const [copied, setCopied] = useState(false)

  // Get the share text from URL parameter
  const shareText = searchParams.get("text") || ""

  const handleCopyToClipboard = () => {
    navigator.clipboard.writeText(shareText)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  const handleShareToLinkedIn = () => {
    const linkedinUrl = `https://www.linkedin.com/feed/?shareActive=true&text=${encodeURIComponent(shareText)}`
    window.open(linkedinUrl, "_blank")
  }

  return (
    <div className="min-h-screen bg-muted p-8">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => navigate(-1)}
            className="mb-4"
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            Back
          </Button>
          <h1 className="text-3xl font-bold text-foreground">
            LinkedIn Share Preview
          </h1>
          <p className="text-muted-foreground mt-2">
            Review the LinkedIn share text before posting
          </p>
        </div>

        {/* Preview Card */}
        <div className="bg-card rounded-lg border border-border p-8 mb-6 shadow-sm">
          <div className="mb-6">
            <h2 className="text-sm font-semibold text-foreground mb-3">
              Preview
            </h2>
            <div className="bg-muted p-6 rounded border border-border min-h-96 whitespace-pre-wrap text-foreground font-mono text-sm leading-relaxed">
              {shareText || "No text to display"}
            </div>
          </div>

          {/* Character Count */}
          <div className="mb-6 text-sm text-muted-foreground">
            Character count:{" "}
            <span className="font-semibold">{shareText.length}</span>
            {shareText.length > 2000 && (
              <span className="ml-2 text-amber-600">
                ⚠️ Aim for under 2,000 characters for best readability (LinkedIn
                max is ~3,000).
              </span>
            )}
          </div>

          {/* Action Buttons */}
          <div className="flex gap-4">
            <Button
              onClick={handleCopyToClipboard}
              className="flex-1"
              variant="outline"
            >
              <Copy className="mr-2 h-4 w-4" />
              {copied ? "Copied!" : "Copy to Clipboard"}
            </Button>
            <Button onClick={handleShareToLinkedIn} className="flex-1">
              Share to LinkedIn
            </Button>
          </div>
        </div>

        {/* Info Box */}
        <div className="bg-blue-50 border border-blue-200 rounded p-4">
          <p className="text-sm text-blue-900">
            <span className="font-semibold">Debug Mode:</span> This page
            displays the text that will be shared to LinkedIn. You can copy it,
            review it, or proceed with sharing directly.
          </p>
        </div>
      </div>
    </div>
  )
}
